@if (isInitialized && isMeterAsymmetric !== null) {
<oe-chart [title]="component.alias +  '&nbsp;-&nbsp;' + ('EDGE.HISTORY.CURRENT_AND_VOLTAGE' | translate)"
    [showPhases]="showPhases" [showTotal]="showTotal" (setShowTotal)="setShowTotal($event)"
    (setShowPhases)="setShowPhases($event)" [period]="service.historyPeriod.value">
    <pickdate custom-pickdate [historyPeriods]="['day', 'week']"></pickdate>
    @if (isMeterAsymmetric) {
    <oe-current-voltage-asymmetric-chart [isOnlyChart]="true"></oe-current-voltage-asymmetric-chart>
    }
    @if (!isMeterAsymmetric) {
    <oe-current-voltage-chart [isOnlyChart]="true"></oe-current-voltage-chart>
    }
    <oe-footer-subnavigation [backButton]="true" [navigationOptions]="[]"></oe-footer-subnavigation>
</oe-chart>
}